export const validate = (form, shippingMethod, selectedLocker) => {
  const errors = {}
  if (!form.name.trim()) errors.name = 'Name is required'
  if (!form.email.trim()) errors.email = 'Email is required'
  else if (!/\S+@\S+\.\S+/.test(form.email)) errors.email = 'Invalid email address'
  if (!form.phone.trim()) errors.phone = 'Phone number is required'
  else if (!/^[\d\s\-+()]{7,15}$/.test(form.phone)) errors.phone = 'Invalid phone number'
  if (shippingMethod === 'direct') {
    if (!form.address.trim()) errors.address = 'Address is required'
    if (!form.city.trim()) errors.city = 'City is required'
    if (!form.province.trim()) errors.province = 'Province is required'
    if (!form.postalCode.trim()) errors.postalCode = 'Postal code is required'
  }
  if (shippingMethod === 'locker' && !selectedLocker) {
    errors.locker = 'Please select a Courier Guy locker'
  }
  return errors
}
